module.exports = __webpack_public_path__ + "media/images/icons/pause-5c73a9fdb9d446fe5a7cbb3d70ed0777.svg";